// extracted by mini-css-extract-plugin
export var externalLink = "_cl-0";
export var internalLinkLabel = "_cl-1";